import type { QueryClient } from '@tanstack/react-query'
import { QUERY_KEY_MY_PUBLIC_ENROLLMENTS } from '../services/publicService'
import {
  asPublicEnrollmentList,
  findActiveFootballParticipant,
  findActiveFormula1Participant,
  upsertPublicEnrollment,
  type PublicGameType,
} from './publicFootballEnrollment'

export type WorldEnrollExtras = {
  tournamentIds: string[]
  countryCode: string
  city: string
}

export function worldHubPath(gameType?: string): '/public/formula1' | '/public/football' {
  return gameType === 'formula1' ? '/public/formula1' : '/public/football'
}

export function asPublicGameType(gameType?: string): PublicGameType | undefined {
  return gameType === 'formula1' || gameType === 'football' ? gameType : undefined
}

/** Optimistic enroll cache + refetch, matching the mobile hub after Play World. */
export async function syncWorldEnrollCache(
  queryClient: QueryClient,
  gameType?: string,
  extras?: WorldEnrollExtras,
): Promise<void> {
  const typed = asPublicGameType(gameType)
  if (typed && extras) {
    queryClient.setQueryData(QUERY_KEY_MY_PUBLIC_ENROLLMENTS, (old: unknown) =>
      upsertPublicEnrollment(asPublicEnrollmentList(old), { gameType: typed, ...extras }),
    )
  }
  await queryClient.refetchQueries({ queryKey: QUERY_KEY_MY_PUBLIC_ENROLLMENTS })
  if (!typed || !extras) return
  const after = asPublicEnrollmentList(queryClient.getQueryData(QUERY_KEY_MY_PUBLIC_ENROLLMENTS))
  const ok =
    typed === 'formula1'
      ? findActiveFormula1Participant(after)
      : findActiveFootballParticipant(after)
  if (!ok) {
    queryClient.setQueryData(QUERY_KEY_MY_PUBLIC_ENROLLMENTS, (old: unknown) =>
      upsertPublicEnrollment(asPublicEnrollmentList(old), { gameType: typed, ...extras }),
    )
  }
}
